import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TrackClicksDirective } from './dom/track-clicks/track-clicks.directive';
import { TrackValuePipe } from './dom/track-value/track-value.pipe';
import { TrackInitDirective } from './lifecycle/track-init/track-init.directive';

const DECLARATIONS = [TrackClicksDirective, TrackValuePipe, TrackInitDirective];

@NgModule({
  imports: [CommonModule],
  declarations: DECLARATIONS,
  exports: DECLARATIONS,
})
export class AnalyticsUiModule {}
